import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { ROUTES } from '../constants';

export function CallToAction() {
  return (
    <section className='py-20 bg-blue-600 text-white'>
      <div className='container mx-auto px-6 text-center'>
        <h2 className='text-3xl font-bold mb-8'>
          <FormattedMessage
            id='cta.title'
            defaultMessage='Готовы предложить свои услуги?'
          />
        </h2>
        <p className='text-xl mb-8 text-blue-100'>
          <FormattedMessage
            id='cta.description'
            defaultMessage='Присоединяйтесь к тысячам профессионалов на NovoService'
          />
        </p>
        <Link to={ROUTES.addService}>
          <button className='bg-white text-blue-600 px-8 py-3 rounded-lg hover:bg-blue-50 font-semibold'>
            <FormattedMessage
              id='cta.button'
              defaultMessage='Создать объявление'
            />
          </button>
        </Link>
      </div>
    </section>
  );
}
